import { restClient } from '../client';
import { TimeRange, WeekDayKeys } from '@uplift/types';


export type AvailabilityTemplateOutput = {
  days: Record<WeekDayKeys, TimeRange[]>;
  timezone: string;
};


export type SetAvailabilityTemplateInput = {
  days: Partial<Record<WeekDayKeys, TimeRange[]>>;
  timezone?: string;
};


export type SetAvailabilityTemplateOutput = AvailabilityTemplateOutput;


export const setAvailabilityTemplate = restClient.createRawRequest<SetAvailabilityTemplateInput, SetAvailabilityTemplateOutput>({
  url: '/api/v1/availability_template',
  method: 'POST',
});


export type GetAvailabilityTemplateOutput = AvailabilityTemplateOutput & {
  total_hours: number;
  configured: boolean;
  overrides: Record<string, TimeRange[]>;
};


export const getAvailabilityTemplate = (params?: { date_from: string; date_to: string }) => restClient.rawRequest<GetAvailabilityTemplateOutput>('/api/v1/availability_template', {
  method: 'GET',
  params: params
});


export const setAvailabilityOverride = restClient.createRawRequest<{ date: string; ranges: TimeRange[] }, { ranges: TimeRange[] }>({
  url: '/api/v1/availability_override',
  method: 'POST',
});
